import 'whatwg-fetch';
import makeAuth0Lock from './auth';


window.addEventListener('load', () => {
  const isLocal = false;

  if (!window.Auth0Lock) {
    return;
  }

  const lock = makeAuth0Lock(isLocal, {
    container: 'embedded-lock',
    allowLogin: false,
  });

  lock.show();

  if (!isLocal) {
    lock.on('signup submit', () => {
      analytics.track('Lead');
      try {
        if (window.source === 'gaw') {
          const clearbitString = window.clearbitData && `
            Name: ${clearbitData.company.name}
            Domain: ${clearbitData.company.domain}
          `;

          window.fetch('https://hooks.slack.com/services/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', {
            method: 'POST',
            body: JSON.stringify({
              text: `*Adwords Signup:*
              ${clearbitString}
            `,
            }),
          });
        }
      // eslint-disable-next-line no-empty
      } catch (e) {}
    });
  }
}, false);
